import { FC, ReactNode } from 'react';
import { Grid } from '@mui/material';

import { Tag } from '@components/base';

type TagItem = {
  icon?: ReactNode;
  key: string;
  label: number | string;
};

type TagGridProps = {
  centered?: boolean;
  maxTags?: false | number;
  softTags?: boolean;
  tags?: (string | TagItem)[];
};

export const TagGrid: FC<TagGridProps> = ({ centered, softTags, maxTags = 3, tags }) => {
  if (!tags) return null;

  const main = maxTags ? tags.slice(0, maxTags) : tags;
  const rest = maxTags ? tags.slice(maxTags) : [];

  return main.length > 0 ? (
    <Grid
      component='span'
      container
      spacing={0.5}
      {...(centered ? { justifyContent: 'center' } : {})}
    >
      {main.map(provider => {
        if (!provider) return null;

        const label = typeof provider === 'string' ? provider : provider.label;
        const key = typeof provider === 'string' ? provider : provider.key;
        const icon = typeof provider === 'string' ? undefined : provider.icon;

        return (
          <Grid key={key}>
            <Tag
              icon={icon}
              label={label}
              soft={softTags}
              title={key === label ? undefined : key}
            />
          </Grid>
        );
      })}

      {rest.length > 0 && (
        <Grid>
          <Tag
            label={`+${rest.length}`}
            soft={softTags}
            title={rest
              .map(item => (typeof item === 'string' ? item : `${item.label} (${item.key})`))
              .join('\n')}
          />
        </Grid>
      )}
    </Grid>
  ) : null;
};
